<template lang="">
    <div>
        <ManageStaffSkills/>
        <br>
        <ManageStaffQualifications/>
    </div>
</template>
<script>
import ManageStaffSkills from './ManageStaffSkills.vue'
import ManageStaffQualifications from './ManageStaffQualifications.vue'
export default {
    components: {
        ManageStaffSkills,
        ManageStaffQualifications
    }
}
</script>
<style lang="">
    
</style>